import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      params: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var newData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;
                _this.params = [];
                newData = data ? JSON.parse(data) : [];
                console.log("this.params", _this.params);
                _this.params = newData.map(function (item) {
                  return {
                    value: item
                  };
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};